import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { lender_filter_result_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import {
  applicationLoanRequestsKeys,
  parseApplicationLoanRequestsKey,
} from '../../cache-keys/applicationLoanRequestsKeys.tsx';

export function useLenderFilterResults(
  applicationID: string,
  requestIDs: string[]
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationLoanRequestsKeys.loanRequestFilters({
    applicationID,
    requestIDs,
  });
  return useQuery(
    cacheKey,
    queryFunction(
      lender_filter_result_api.getLenderFilterResults(api),
      ({ queryKey }) =>
        parseApplicationLoanRequestsKey(queryKey).requestIDs ?? []
    ),
    {
      enabled:
        state.user.token.length > 0 && requestIDs.length > 0 && !!applicationID,
    }
  );
}
